/// <amd-module name="Feed/Connect/Protocols/npm" />
import { replaceRouteValues } from "VSS/Platform/Util/Url";
import * as Utils_Url from "VSS/Platform/Util/Url";

import { PackagingService } from "Feed/Core/PackagingService";
import { IUxFeedView } from "Feed/Core/UxFeedView";

import { PackagingProcotol } from "../Protocol";
import { PackagingTool, ToolId } from "../Tool";

import * as Res from "Feed/Connect/Resources";

class NpmProtocol extends PackagingProcotol {
    constructor() {
        super("npm");
    }

    public readonly area = "npm";

    public getFeedUrl(packagingService: PackagingService, feed: IUxFeedView) {
        // TODO: Move route resolution to endpoints within this object
        const path = replaceRouteValues("_packaging/{feedId}/{area}/{resource}{packageName}", {
            feedId: feed.name,
            area: this.area,
            resource: "registry"
        });

        return packagingService.getUrl(feed.project, path + "/");
    }
}

const npmProtocol = new NpmProtocol();

export class NpmTool extends PackagingTool {
    constructor(id: ToolId, name: string, imageName: string, private toolLinkId: number) {
        super(id, name, npmProtocol, { src: `ms.feed/feed-connect/Content/${imageName}` });
    }

    public getToolLink = () => ({
        href: `https://go.microsoft.com/fwlink/?linkid=${this.toolLinkId}`,
        children: `${Res.CommandLineReference}`
    });

    public getNerfDart(packagingService: PackagingService, feed: IUxFeedView, stripRegistry: boolean = false) {
        const feedUrl = this.getFeedUrl(packagingService, feed);
        const urlWithRegistry = NpmTool.getNpmAuthUrl(feedUrl);

        if (stripRegistry) {
            return urlWithRegistry.replace(/\/registry\/?$/, "/");
        }

        return urlWithRegistry;
    }

    public static getNpmAuthUrl(registryEndpointUrl: string) {
        const uri = new Utils_Url.Uri(registryEndpointUrl);
        // @ts-ignore TypeScript 4.0 upgrade
        delete uri.scheme;
        // @ts-ignore TypeScript 4.0 upgrade
        delete uri.queryParameters;
        // @ts-ignore TypeScript 4.0 upgrade
        delete uri.hashString;

        const lastSlashIndex = uri.path.lastIndexOf("/");
        // include everything up to the last slash, discard everything after it (including the slash):
        const path = lastSlashIndex > 0 ? "/" + uri.path.substr(0, lastSlashIndex) : "";

        // absoluteUri encodes the path, which means it won't match the registry uri property. We'll append it ourselves.
        // @ts-ignore TypeScript 4.0 upgrade
        delete uri.path;

        // this is mimicking NPM's 'toNerfDart' behavior.
        return "//" + Utils_Url.combineUrlPaths(uri.absoluteUri, path) + "/";
    }
}

export const npm = new NpmTool(ToolId.npm, "npm", "npm.svg", 2103788);
